// DS: i11.20
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const RemoveBackground: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M20.707 3.293a1 1 0 0 1 0 1.414l-16 16a1 1 0 0 1-1.414-1.414l16-16a1 1 0 0 1 1.414 0m-12 0a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0m6 1.414a1 1 0 0 0-1.414-1.414l-10 10a1 1 0 1 0 1.414 1.414zm6 4.586a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414-1.414l10-10a1 1 0 0 1 1.414 0m0 7.414a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 0 0 1.414 1.414z"
        ></path>
      </svg>
    </IconWrap>
  );
};
RemoveBackground.displayName = 'RemoveBackground';

export default RemoveBackground;
